<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table responsive selectable"
               matSort matSortActive="name" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Name:</span>
          <span>{{ row.name }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="phoneNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header="phoneNumber">Phone Number</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Phone Number:</span>
          {{ row.phoneNumber  | phoneNumber }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="phoneType">
        <mat-header-cell *matHeaderCellDef mat-sort-header="phoneType">Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Type:</span>
          {{ row.phoneType }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="recordType">
        <mat-header-cell *matHeaderCellDef mat-sort-header="recordType">Directory</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Directory:</span>
          {{ row.recordType == 0 ? 'Company' : 'Private' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tags">
        <mat-header-cell *matHeaderCellDef>Tags</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Directory:</span>
          <app-tags [tags]="row.tags"></app-tags>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"
               (click)=" selectedRows.toggle(row)"
               [class.selected-row]="selectedRows.isSelected(row)"
      ></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
